import { setSort } from "../QualificationListSlice";
import { Dispatch } from "redux";
import { QualificationListSortEnum } from "../../../common/enums/QualificationListSortEnum";

interface Props {
    dispatch: Dispatch;
    sort: {
        sortName: string;
        isSorted: boolean;
    };
}

export const handleSort = (props: Props) => () => {
    const { dispatch, sort } = props;

    switch (sort.sortName) {
        case QualificationListSortEnum.QUALIFICATION:
            dispatch(
                setSort({
                    sortName: sort.isSorted
                        ? QualificationListSortEnum.QUALIFICATION_ASC
                        : QualificationListSortEnum.QUALIFICATION_DESC,
                    isSorted: !sort.isSorted,
                }),
            );
            break;
        case QualificationListSortEnum.TYPE:
            dispatch(
                setSort({
                    sortName: sort.isSorted
                        ? QualificationListSortEnum.TYPE_ASC
                        : QualificationListSortEnum.TYPE_DESC,
                    isSorted: !sort.isSorted,
                }),
            );
            break;
        default:
            break;
    }
};
